import { useTranslation } from "react-i18next";
import { CrossIcon, FridgeIcon } from "@/shared/icons";
import { SoundButton } from "@/shared/ui";

type Props = {
  onClose: () => void;
};

export default function EstateFridgeHeader({ onClose }: Props) {
  const { t } = useTranslation("estate");
  return (
    <header className="flex items-center min-h-[4.875rem] mb-3.5 pl-7.5 pr-7.5 bg-[url(/svg/home-menu/header/fridge.svg)] bg-center bg-no-repeat rounded-bl-4">
      <div className="flex items-center gap-2">
        <FridgeIcon className="size-6" />
        <p className="text-14 font-bold uppercase leading-none">{t("estate.fridge.fridge")}</p>
      </div>
      <SoundButton
        className="size-8 ml-auto p-0 rounded-xl bg-dark-800 hover:brightness-110"
        variant="soft"
        onClick={onClose}
      >
        <CrossIcon className="size-3" />
      </SoundButton>
    </header>
  );
}
